<template>
  <div>
    <!-- sekilas info -->
    <div class="sekilas-info">
      <h4 class="judul-section">Sekilas Info</h4>
      <div class="list-card-info">
        <!-- card info karyawan aktif -->
        <div class="card-info">
          <!-- icon info -->
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#FFB700" />
            <rect
              width="20"
              height="20"
              transform="translate(10 10)"
              fill="#FFB700"
            />
            <path
              d="M23.5715 26.4284V24.9999C23.5715 24.2421 23.2704 23.5154 22.7346 22.9796C22.1988 22.4437 21.4721 22.1427 20.7143 22.1427H15C14.2423 22.1427 13.5155 22.4437 12.9797 22.9796C12.4439 23.5154 12.1429 24.2421 12.1429 24.9999V26.4284M27.8572 26.4284V24.9999C27.8567 24.3668 27.646 23.7518 27.2581 23.2515C26.8703 22.7512 26.3273 22.3938 25.7143 22.2356M22.8572 13.6641C23.4718 13.8215 24.0165 14.1789 24.4055 14.6801C24.7945 15.1812 25.0056 15.7976 25.0056 16.432C25.0056 17.0664 24.7945 17.6828 24.4055 18.1839C24.0165 18.6851 23.4718 19.0425 22.8572 19.1999M20.7143 16.4284C20.7143 18.0064 19.4351 19.2856 17.8572 19.2856C16.2792 19.2856 15 18.0064 15 16.4284C15 14.8505 16.2792 13.5713 17.8572 13.5713C19.4351 13.5713 20.7143 14.8505 20.7143 16.4284Z"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="detail-info">
            <h4>Karyawan Aktif</h4>
                <h3>{{ sekilasInfo.karyawanAktif }}</h3>
          </div>
          <!-- end of icon info -->
        </div>
        <!-- end of card info karyawan aktif-->

        <!-- card info jumlah divisi -->
        <div class="card-info">
          <!-- icon info -->
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#EB5757" />
            <rect
              width="20"
              height="20"
              transform="translate(10 10)"
              fill="#EB5757"
            />
            <path
              d="M23.5715 26.4284V24.9999C23.5715 24.2421 23.2704 23.5154 22.7346 22.9796C22.1988 22.4437 21.4721 22.1427 20.7143 22.1427H15C14.2423 22.1427 13.5155 22.4437 12.9797 22.9796C12.4439 23.5154 12.1429 24.2421 12.1429 24.9999V26.4284M27.8572 26.4284V24.9999C27.8567 24.3668 27.646 23.7518 27.2581 23.2515C26.8703 22.7512 26.3273 22.3938 25.7143 22.2356M22.8572 13.6641C23.4718 13.8215 24.0165 14.1789 24.4055 14.6801C24.7945 15.1812 25.0056 15.7976 25.0056 16.432C25.0056 17.0664 24.7945 17.6828 24.4055 18.1839C24.0165 18.6851 23.4718 19.0425 22.8572 19.1999M20.7143 16.4284C20.7143 18.0064 19.4351 19.2856 17.8572 19.2856C16.2792 19.2856 15 18.0064 15 16.4284C15 14.8505 16.2792 13.5713 17.8572 13.5713C19.4351 13.5713 20.7143 14.8505 20.7143 16.4284Z"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div class="detail-info">
            <h4>Karyawan cuti</h4>
                <h3>{{ sekilasInfo.karyawanCuti }}</h3>
          </div>
          <!-- end of icon info -->
        </div>
        <!-- end of card info divisi -->
      </div>
    </div>
    <!-- end of sekilas info -->

    <!-- data karyawan -->
    <DataKaryawan />
    <!-- end of data karyawan -->
  </div>
</template>

<script>
import DataKaryawan from "@/components/ceo/hrd/DataKaryawan";
import * as soluhaApi from "@/soluhaApi";

export default {
  components: {
    DataKaryawan,
  },

  data() {
    return {
      // data sekilas info
      sekilasInfo: {
        karyawanAktif: 0,
        karyawanCuti: 0,
      },
    };
  },

  methods: {
    async getSekilasInfo() {
      let sekilasInfo = await soluhaApi.getSekilasInfo();
      this.sekilasInfo.karyawanAktif = sekilasInfo.karyawanAktif;
      this.sekilasInfo.karyawanCuti = sekilasInfo.karyawanCuti;
    },
  },

  mounted() {
    this.getSekilasInfo();
  },
};
</script>

<style scoped>
@import url("../../../assets/css/hrd/dashboard.css");
</style>
